import { paths } from 'config'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'
import { isGlobalworth } from 'config'
import { Lan } from '@mui/icons-material'
import { createElement } from 'react'

const NetworkLanIcon = () =>
  createElement(Lan, { color: isGlobalworth ? 'primary' : 'inherit' })

const routes: ModuleRoute[] = [
  {
    path: paths.lanMonitoring,
    admin: false,
    exact: true,
    linkSettings: {
      label: 'nav.networkMonitoring',
      icon: NetworkLanIcon,
    },
    component: Loadable({
      component: () => import('./pages/NetworkMonitoring'),
    }),
    layoutSettings: {},
  },
]

export default routes


